<div class="row contact-container">
  <div class="d-block d-md-none">
    <h1>{{ "Let’s Get In Touch, How Can We Help?" | translate }}</h1>
    <p>
      {{ "Have questions about pricing" | translate }}
    </p>
  </div>
  <div class="col-12 col-md-6 col-lg-7 left-container order-md-1 order-2">
    <div class="d-none d-md-block">
      <h1>{{ "Let’s Get In Touch, How Can We Help?" | translate }}</h1>
      <p>
        {{ "Have questions about pricing" | translate }}
      </p>
    </div>

    <img
      width="100%"
      class="d-none d-md-block contact-img"
      src="{{ contactImage }}"
    />

    <div class="d-flex justify-content-between align-items-center mt-3">
      <div>
        <i class="bi bi-envelope" *ngIf="emailpath">
          <div class="mx-2 d-inline">{{ emailpath }}</div>
        </i>

        <br />

        <i class="bi bi-telephone"
          ><div dir="ltr" class="mx-2 d-inline">{{ whatsappNumber }}</div>
        </i>

        <br />
        <div class="d-flex flex-column" *ngIf="locations">
          <div *ngFor="let loc of locations" class="location">
            <i class="bi bi-geo-alt-fill text-danger"></i>
            <span class="social-text mx-2">{{ loc | translate }}</span>
          </div>
        </div>
        <div class="d-flex flex-column" *ngIf="emails">
          <div *ngFor="let email of emails">
            <i class="bi bi-envelope"></i>
            <span class="social-text mx-2">{{ email }} </span>
          </div>
        </div>
        <!-- <i class="bi bi-geo-alt"
          ><div class="mx-2 d-inline">Egypt, Cairo</div>
        </i> -->
      </div>
      <div class="d-flex gap-2 gap-sm-4 social">
        <a
          *ngFor="let link of soicalMediaLinks"
          [href]="link.link || link.path"
          [attr.download]="link.name === 'portfolio' ? 'portfolio.pdf' : null"
          target="{{ link.name === 'portfolio' ? '_self' : '_blank' }}"
        >
          <fa-icon [icon]="icons[link.icon]"></fa-icon>
        </a>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-6 col-lg-5 p-0 order-md-2 order-1">
    <div class="form-container">
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <label>{{ "Full Name" | translate }}</label>
        <div class="input-container mt-1">
          <i class="bi bi-person fs-4 left-icon"></i>
          <input
            type="text"
            name="fullName"
            formControlName="fullName"
            placeholder="{{ 'Enter your fullName' | translate }}"
          />
        </div>
        <div
          *ngIf="
            contactForm.get('fullName')?.touched &&
            contactForm.get('fullName')?.invalid
          "
          class="validation-message"
        >
          <div *ngIf="contactForm.get('fullName')?.errors?.['required']">
            Full name is required.
          </div>
          <div *ngIf="contactForm.get('fullName')?.errors?.['pattern']">
            Only alphabetic characters and spaces are allowed.
          </div>
        </div>

        <div class="mt-3">
          <label>{{ "Phone Number" | translate }}</label>
          <div class="input-container mt-1">
            <i class="bi bi-telephone fs-5 left-icon"></i>
            <input
              type="text"
              name="phone"
              formControlName="phoneNumber"
              placeholder="{{ 'Enter your phone number' | translate }}"
            />
          </div>
          <div
            *ngIf="
              contactForm.get('phoneNumber')?.touched &&
              contactForm.get('phoneNumber')?.invalid
            "
            class="validation-message"
          >
            <div *ngIf="contactForm.get('phoneNumber')?.errors?.['required']">
              Phone number is required.
            </div>
            <div *ngIf="contactForm.get('phoneNumber')?.errors?.['pattern']">
              Phone number can only contain numbers.
            </div>
            <div
              *ngIf="contactForm.get('phoneNumber')?.errors?.['minlength'] || contactForm.get('phoneNumber')?.errors?.['maxlength']"
            >
              Phone number must be 11 digits.
            </div>
          </div>
        </div>
        <div class="mt-3">
          <label>{{ "Email" | translate }}</label>
          <div class="input-container mt-1">
            <i class="bi bi-envelope fs-5 left-icon"></i>
            <input
              type="email"
              name="email"
              formControlName="email"
              placeholder="{{ 'Enter your email' | translate }}"
            />
          </div>
          <div
            *ngIf="
              contactForm.get('email')?.touched &&
              contactForm.get('email')?.invalid
            "
            class="validation-message"
          >
            <div *ngIf="contactForm.get('email')?.errors?.['required']">
              Email is required.
            </div>
            <div *ngIf="contactForm.get('email')?.errors?.['email']">
              Please enter a valid email address.
            </div>
          </div>
        </div>

        <div class="mt-3">
          <label>{{ "Message" | translate }} </label>
          <div class="input-container mt-1">
            <i class="bi bi-chat-left-text fs-5 left-icon area-icon"></i>

            <textarea
              type="text"
              name="message"
              formControlName="message"
              placeholder="{{ 'Enter your message' | translate }}"
            ></textarea>
          </div>
          <div
            *ngIf="
              contactForm.get('message')?.touched &&
              contactForm.get('message')?.invalid
            "
            class="validation-message"
          >
            <div *ngIf="contactForm.get('message')?.errors?.['required']">
              Message is required.
            </div>
            <div *ngIf="contactForm.get('message')?.errors?.['minlength']">
              Message must be at least 5 characters long.
            </div>
          </div>
        </div>

        <button type="submit" class="w-100 py-2 btn mt-3">
          {{ "Send" | translate }}
        </button>
      </form>
      <div class="or-divider my-4">
        <div class="line"></div>
        <label>{{ "Or" | translate }}</label>
        <div class="line"></div>
      </div>
      <a [href]="whatsappLink" target="_blank">
        <button class="contact-btn py-1">
          <img [src]="whatAppPath" />
          {{ "Contact with us by Whatsapp" | translate }}
        </button>
      </a>
    </div>
  </div>
</div>
